module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/krn-web/images/merchant_free_shipping_benefit.7c2d6141ec.png";